﻿import * as $ from 'jquery';
import { IDialog, IDialogOptions } from 'runtime/dialogs/dialog';
import { ValidationControl } from 'runtime/controls/validationcontrol';
import { IResourceProvider } from 'common/resourceprovider';
import { ValidationItem, ValidationSummary } from 'shared/data/validation';
import { ControlArgs } from 'runtime/controls/controlargs';

export class ValidationReportDialog implements IDialog {
    options: IDialogOptions;
    private vc: ValidationControl;
    private dialogContent: JQuery;

    constructor(validationItems: ValidationItem[], resources: IResourceProvider) {
        this.options = {
            title: resources.getCoreString('LblBulkActionResult'),
            width: 680,
            height: 430,
            dialogClass: 'wf-worktray-item-dialog',
            buttons: [
                {
                    text: resources.getCoreString('ExpandErrors'),
                    click: () => this.vc.expandErrors()
                },
                {
                    text: resources.getCoreString('ExpandAll'),
                    click: () => this.vc.expandAll()
                },
                {
                    text: resources.getCoreString('CollapseAll'),
                    click: () => this.vc.collapseAll()
                },
                {
                    text: resources.getCoreString('XamlClose'),
                    click: () => this.dialogContent.dialog('close')
                }
            ],
            create: () => {
                var vs = new ValidationSummary('', '', '', validationItems);
                this.vc.validationSummary = vs;
                this.vc.render();
                this.vc.collapseAll();
            }
        };
        this.dialogContent = this.buildContent(resources);
    }

    content(): JQuery {
        return this.dialogContent;
    }

    close(): void {
        this.dialogContent.dialog('close');
    }

    private buildContent(resources: IResourceProvider): JQuery {
        var $element = $('<div />');

        var config = {
            elementName: 'ValidationReport',
            'content.TextAlignment': 'left',
            'content.FontSize': 'inherit',
            'content.FontWeight': 'inherit'
        };

        var args = ControlArgs.createMock($element, config, null, null, resources);

        this.vc = new ValidationControl(args);

        return $('<div />').append($element);
    }
}
